import { render, staticRenderFns } from "./SiteDocumentNewFormFrGroup.vue?vue&type=template&id=61699acd&"
import script from "./SiteDocumentNewFormFrGroup.vue?vue&type=script&lang=js&"
export * from "./SiteDocumentNewFormFrGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports